import React, { useEffect, useMemo } from "react";
import { Box, Grid, Typography, TextField, MenuItem, Button } from "@mui/material";

const naacOptions = [
  { score: "3.51-4.00", grade: "A++", status: "Accredited" },
  { score: "3.26-3.50", grade: "A+",  status: "Accredited" },
  { score: "3.01-3.25", grade: "A",   status: "Accredited" },
  { score: "2.76-3.00", grade: "B++", status: "Accredited" },
  { score: "2.51-2.75", grade: "B+",  status: "Accredited" },
  { score: "2.01-2.50", grade: "B",   status: "Accredited" },
  { score: "1.51-2.00", grade: "C",   status: "Accredited" },
  { score: "≤1.50",     grade: "D",   status: "Not Accredited" },
];

const AccreditationNAAC = ({
  option,
  data = {},
  onChange,
  renderUploadSection,
  readOnly = false,
}) => {
  const defaultOpt = naacOptions[0];

  useEffect(() => {
    if (readOnly) return;
    if (!data?.score || !naacOptions.some(o => o.score === data.score)) {
      onChange?.({ score: defaultOpt.score, grade: defaultOpt.grade, status: defaultOpt.status });
    } else if (!data.grade || !data.status) {
      const found = naacOptions.find(o => o.score === data.score) || defaultOpt;
      onChange?.({ grade: found.grade, status: found.status });
    }
  }, [readOnly]);

  const selected = useMemo(
    () => naacOptions.find(o => o.score === data?.score) || defaultOpt,
    [data?.score]
  );

  const handleScoreChange = (e) => {
    const val = e.target.value;
    const found = naacOptions.find(o => o.score === val) || defaultOpt;
    onChange?.({ score: found.score, grade: found.grade, status: found.status });
  };

  return (
    <Box display="flex" gap={2}>
      {/* Left: Logo */}
      <Box sx={{ width: 80, pt: 1 }}>
        <img
          src="/assets/images/university-logo/naac-logo.png"
          alt="NAAC Logo"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </Box>

      {/* Right: Text + Inputs */}
      <Box flex={1}>
        <Typography fontSize={14} fontWeight={600} color="#15243E" mb={2}>
          {option?.label}
        </Typography>

        <Grid container spacing={2}>
          <Grid xs={12} md={3} lg={3}>
            <Typography fontSize={13} fontWeight={500} mb={0.5}>
              Score
            </Typography>
            <TextField
              select
              fullWidth
              size="small"
              value={selected.score}
              onChange={handleScoreChange}
              disabled={readOnly}
              sx={{
                "& .MuiInputBase-root": { height: 38 },
                "& .MuiSelect-select": { fontSize: "13px", padding: "6px 12px" },
              }}
            >
              {naacOptions.map((opt) => (
                <MenuItem key={opt.score} value={opt.score} sx={{ fontSize: "13px" }}>
                  {opt.score}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid xs={12} md={2}>
            <Typography fontSize={13} fontWeight={500} mb={0.5}>
              Grade
            </Typography>
            <TextField
              fullWidth
              size="small"
              value={selected.grade}
              InputProps={{ readOnly: true }}
              disabled
              sx={{
                "& .MuiInputBase-root": { height: 38 },
                "& .MuiInputBase-input": { fontSize: "13px", padding: "8px 12px" },
              }}
            />
          </Grid>

          <Grid xs={12} md={2}>
            <Typography fontSize={13} fontWeight={500} mb={1}>
              Status
            </Typography>
            <Button
              fullWidth
              size="small"
              disabled
              sx={{
                borderRadius: "30px",
                fontSize: "13px",
                fontWeight: 500,
                textTransform: "capitalize",
                padding: "3px 15px",
                backgroundColor: selected.status === "Accredited" ? "#C8FFDA" : "#FFC8D7",
                color: "#363853",
                "&:hover": {
                  backgroundColor: selected.status === "Accredited" ? "#C8FFDA" : "#FFC8D7",
                },
              }}
            >
              {selected.status}
            </Button>
          </Grid>
        </Grid>

        <Box display="block">{renderUploadSection()}</Box>
      </Box>
    </Box>
  );
};

export default AccreditationNAAC;
